import { render, staticRenderFns } from "./license-list.vue?vue&type=template&id=8de97348&scoped=true"
import script from "./license-list.vue?vue&type=script&lang=js"
export * from "./license-list.vue?vue&type=script&lang=js"
import style0 from "./license-list.vue?vue&type=style&index=0&id=8de97348&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de97348",
  null
  
)

export default component.exports